export enum TransportSätt {
  Vägtransport = "R",
  Järnvägstransport = "T",
  Sjötransport = "S",
  Flygtransport = "A",
  Inlandssjöfart = "W",
  Rörledning = "P",
}

export const TransportSättDropdownItems = [
  {
    label: "Vägtransport",
    value: TransportSätt.Vägtransport,
  },
  {
    label: "Järnvägstransport",
    value: TransportSätt.Järnvägstransport,
  },
  {
    label: "Sjötransport",
    value: TransportSätt.Sjötransport,
  },
  {
    label: "Flygtransport",
    value: TransportSätt.Flygtransport,
  },
  {
    label: "Inlandssjöfart",
    value: TransportSätt.Inlandssjöfart,
  },
  {
    label: "Rörledning",
    value: TransportSätt.Rörledning,
  },
];
